import { render, staticRenderFns } from "./UpsellScheduled.vue?vue&type=template&id=64552419&scoped=true"
import script from "./UpsellScheduled.vue?vue&type=script&lang=js"
export * from "./UpsellScheduled.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64552419",
  null
  
)

export default component.exports